import { takeEvery, call, put } from "redux-saga/effects";
import { buildGETUrl } from "../../utilities/buildGETUrl";
import {
  UPDATE_VIDEOS_POSITIONS,
  loadVideolist,
  loadVideolists,
} from "../../store/ContentVideolists/actions";
import {
  showAlertError,
  showAlertSuccess,
  showAlertInfo,
} from "../../store/Alert/actions";
import axios from "axios";
import { loading } from "../../store/App/actions";
import { baseURL } from "../root";

export default function* () {
  yield takeEvery(UPDATE_VIDEOS_POSITIONS, worker);
}

function* worker({ payload }) {
  yield put(loading(true));
  yield put(
    showAlertInfo({
      text: "Процесс может занять некоторое время",
    })
  );
  try {
    const added = yield call(fetchSet, payload);

    if (added.error) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${UPDATE_VIDEOS_POSITIONS}.`, added],
          text: "Видео не было перемещено. Попробуйте повторить.",
        })
      );
    } else {
      // yield put(showAlertSuccess({
      //     text: "Список успешно изменен."
      // }))
      yield put(loadVideolist(payload.id_videolist || payload.videolist_id));
    }
  } catch (e) {
    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${UPDATE_VIDEOS_POSITIONS}.`, e],
        text: "Видео не было перемещено. Попробуйте повторить.",
      })
    );
  } finally {
    yield put(loading(false));
  }
}

function fetchSet(addData) {
  console.log({ addData });

  let formData = new FormData();

  if (addData && (addData.songs || addData.turn)) {
    Object.keys(addData).forEach((name) => {
      // Исправленная проверка для пропуска поля 'id' (если это не turn запрос)
      if (addData.turn || name !== "id") {
        const value = addData[name];

        if (Array.isArray(value)) {
          // Для каждого элемента массива добавляем отдельное поле
          value.forEach((el, index) => {
            formData.append(`${name}[]`, el);
          });
        } else {
          formData.set(name, value);
        }
      }
    });
  }

  return axios({
    url: addData.turn
      ? `${baseURL}/videolist/tracks/turn/set`
      : `/videolist/set?id=${addData.id_videolist}`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => response.data);
}
